import { NgModule } from '@angular/core'
import { DeclareDirective } from './declare.directive'

@NgModule({
  imports: [],
  declarations: [DeclareDirective],
  exports: [DeclareDirective],
})
export class DeclareModule {}
